import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_TAGS_APP_ROOT = `${BASE_ADMIN_V2_PATH}/tags`;

export const ADMIN_TAGS_APP_PATHS = {
  TAGS_LIST: `${ADMIN_TAGS_APP_ROOT}`,
};
